<template>
    <div class="modal-overlay" v-if="showModal">
        <div class="modal-content bg-danger btn-rounded">
            <span class="close-btn text-white" @click="closeModal">&times;</span>

            <!-- batas -->

            <div class="card shadow-sm border-0 mt-4">
                <!-- Header -->
                <div class="px-4 py-3 d-flex justify-content-between align-items-center flex-wrap">
                    <div class="fw-bold"></div>
                    <small class="text-end text-primary">Pesan masuk</small>
                </div>

                <!-- Body -->
                <div class="card-body p-4">
                    <!-- Title -->
                    <div class="row mb-3">
                        <div class="col-md-6">
                            <h5 class="fw-bold mb-0">RUANG KONSULTASI</h5>
                        </div>
                        <div class="col-md-6 text-md-end mt-2 mt-md-0">
                            <small class="text-muted">Tanggal</small>
                            <br />
                            {{ selectedItem && selectedItem.created_date ? formatDate(selectedItem.created_date) : "-" }}
                        </div>
                    </div>

                    <hr />

                    <!-- Info -->
                    <div class="row g-3">
                        <div class="col-md-6">
                            <small class="text-muted">Nama</small>
                            <div class="fw-semibold text-black">{{ selectedItem?.nama || "-" }}</div>
                        </div>

                        <div class="col-md-6 mb-2">
                            <small class="text-muted">Email</small>
                            <div class="fw-semibold text-black">{{ selectedItem?.email || "-" }}</div>
                        </div>

                        <div class="col-md-6 mb-2">
                            <small class="text-muted">Company</small>
                            <div class="fw-semibold text-black">{{ selectedItem?.company || "-" }}</div>
                        </div>

                        <div class="col-md-6 mb-2">
                            <small class="text-muted">Phone</small>
                            <div class="fw-semibold text-black">{{ selectedItem?.no_tlp || "-" }}</div>
                        </div>

                        <div class="col-md-6 mb-2">
                            <small class="text-muted">Kebutuhan</small>
                            <br />
                            <span class="badge bg-secondary px-4 py-2 mt-1 btn-xxs text-white">{{ selectedItem?.jenis || "-" }}</span>
                        </div>
                    </div>

                    <!-- Message -->
                    <div class="mt-4">
                        <small class="text-muted">Pesan</small>
                        <div class="border rounded p-3 mt-1 bg-white">
                            <p class="mb-0 text-muted">
                                {{ selectedItem?.deskripsi || "-" }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- batas -->
        </div>
    </div>
</template>

<script>
export default {
    props: {
        showModal: Boolean,
        selectedItem: Object,
    },
    methods: {
        closeModal() {
            this.$emit("close");
        },
        formatDate(value) {
            if (value) {
                const date = new Date(value);

                const days = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
                const dayName = days[date.getDay()];

                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();

                return `${dayName}, ${day}-${month}-${year}`;
            }
            return "";
        },
    },
};
</script>

<style>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}
.modal-content {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    width: 80%;
    max-width: 800px;
    position: relative;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.close-btn {
    position: absolute;
    top: 10px;
    right: 15px;
    font-size: 20px;
    cursor: pointer;
}
.detail-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
}
.detail-table th,
.detail-table td {
    padding: 10px;
    border: 1px solid #ddd;
    text-align: left;
    vertical-align: top;
}
.detail-table th {
    background-color: #f4f4f4;
    width: 25%;
}
.detail-table td {
    width: 25%;
}
</style>
